import { render, staticRenderFns } from "./ScreenAutoScrollTable.vue?vue&type=template&id=f9c382b8&scoped=true"
import script from "./ScreenAutoScrollTable.vue?vue&type=script&lang=js"
export * from "./ScreenAutoScrollTable.vue?vue&type=script&lang=js"
import style0 from "./ScreenAutoScrollTable.vue?vue&type=style&index=0&id=f9c382b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c382b8",
  null
  
)

export default component.exports